import React from "react";
import {styled} from "styled-components";
import {colors} from "@material-ui/core";

import {Test} from "common/flowmaster/types/test";
import {WorkflowState} from "common/flowmaster/types/workflow_state";

type Props = {
  state: WorkflowState;
  tests: Test[];
};

const Key = styled.span`
  font-weight: bold;
  margin-right: 0.5em;
`;

export default function Summary({state, tests}: Props) {
  const test = tests[0];
  if (!test) {
    return null;
  }

  const value = state.data_store[test.data_key][test.key];
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        padding: "1em",
        backgroundColor: colors.blue[200],
        gap: "1em",
        maxHeight: "33%",
      }}
    >
      <span>
        <Key style={{textTransform: "capitalize"}}>{test.data_key}:</Key>
        <span>{test.key}</span>
      </span>
      <span style={{display: "flex"}}>
        <Key>Value:</Key>
        <span style={{maxHeight: "30em", overflowY: "auto"}}>
          {typeof value === "string" ? (
            value
          ) : (
            <pre style={{whiteSpace: "pre-wrap"}}>
              {JSON.stringify(value, null, 2)}
            </pre>
          )}
        </span>
      </span>
    </div>
  );
}
